import { IPaginationParams } from 'APIPackage/MainModule/interfaces/IPaginationParams';
import { createPaginationParams } from 'APIPackage/MainModule/common/createPaginationParams';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';
import { IKnmSupervisionType } from 'APIPackage/CatalogsModule/interfaces/IKnmSupervisionType';
import { apiGet } from 'APIPackage/MainModule/common/apiTools';

import { FEDERAL_LOW_248_GUID } from '../../../KnmPackage/MainModule/constants/erknmFederalLawUuid';
import { ISupervisionType } from '../../DictionariesModule/interfaces/ISupervisionType';

export async function fetchKnmSupervisionTypesAll(params?: IPaginationParams): Promise<IKnmSupervisionType[]> {
  const queryParams = createPaginationParams(params || {});

  return apiGet<IKnmSupervisionType[]>(
    `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE, true)}/catalogs/knm-supervision-types/all${
      queryParams.toString().length ? `?${queryParams}` : ''
    }`,
  );
}

export async function fetchKnmSupervisionTypesAllWithFederalLaw(): Promise<IKnmSupervisionType[]> {
  return apiGet<IKnmSupervisionType[]>(
    `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE, true)}/catalogs/knm-supervision-types/all-with-federal-law`,
  );
}

export async function fetchKnm248SupervisionTypesErvkByFederalLaw(): Promise<ISupervisionType[]> {
  return apiGet<ISupervisionType[]>(
    `${getServiceBaseURL(
      APIServiceEnum.BASE_SERVICE,
      false,
    )}/catalogs/knm-supervision-types/all-by-federal-law/${FEDERAL_LOW_248_GUID}`,
  );
}

export async function fetchErpSupervisionTypesErvkByFederalLaw(): Promise<ISupervisionType[]> {
  return apiGet<ISupervisionType[]>(
    `${getServiceBaseURL(
      APIServiceEnum.BASE_SERVICE,
      true,
    )}/catalogs/knm-supervision-types/all-without-federal-law/${FEDERAL_LOW_248_GUID}`,
  );
}
